import { useLocalization } from "../egencia-provider/index.js";
import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
export class Loader extends React.Component {
  static displayName = "UitkLoader";
  static defaultProps = {
    isDarkBackground: false,
    isSmall: false
  };
  render() {
    const { className, isDarkBackground, isSmall, l10n, title, ...props } = this.props;
    const loaderTitle = title || l10n.formatText("loading");
    const baseClassName = "uitk-loader";
    const cssClassNames = classNames(baseClassName, className, {
      [`${baseClassName}-dark`]: isDarkBackground,
      [`${baseClassName}-small`]: isSmall
    });
    return /* @__PURE__ */ React.createElement("span", { className: cssClassNames, title: loaderTitle, "aria-label": loaderTitle, ...props });
  }
}
export const UitkLoader = (props) => {
  const l10n = useLocalization();
  return /* @__PURE__ */ React.createElement(Loader, { l10n, ...props });
};
